"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.POPUP_CONTAINER = exports.BTN_CONTAINER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    BTN_CONTAINER = (0, _cxs["default"])({
  display: "flex",
  backgroundRepeat: "no-repeat",
  border: "none",
  cursor: "pointer",
  overflow: "hidden",
  outline: "none",
  flexDirection: "column",
  borderRadius: "3px",
  backgroundColor: "transparent"
});

exports.BTN_CONTAINER = BTN_CONTAINER;
var POPUP_CONTAINER = (0, _cxs["default"])({
  cursor: "pointer",
  backgroundColor: _vars.COLOURS.mono.white,
  borderRadius: "3px",
  marginBottom: "4px",
  boxShadow: "0 2px 4px 0 ".concat(_vars.COLOURS.mono.black50),
  overflow: "hidden"
});
exports.POPUP_CONTAINER = POPUP_CONTAINER;